import React, {
  DetailedHTMLProps,
  HTMLInputTypeAttribute,
  InputHTMLAttributes,
  ReactNode,
} from 'react'
import { useFormContext } from 'react-hook-form'
import InputWithFloatingLabel from '@/features/quiz/inputs/input-with-floating-label'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

type QuizTextInputProps = {
  name: string
  label: string
  hasError?: boolean
  contentAtEnd?: ReactNode
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>

export default function QuizTextInput({
  name,
  type,
  label,
  hasError,
  contentAtEnd,

  ...props
}: QuizTextInputProps) {
  const { register, watch, formState } = useFormContext()
  const value = watch(name)
  const field = register(name)
  const { isSubmitting, isSubmitted, errors, touchedFields } = formState
  const touched = touchedFields?.[name] || isSubmitted
  const error = errors[name]
  const isDisabled = isSubmitting || props.disabled

  return (
    <div>
      <InputWithFloatingLabel
        name={name}
        type={type}
        label={label}
        contentAtEnd={contentAtEnd}
        disabled={isDisabled}
        hasError={Boolean((touched && error) || hasError)}
        aria-invalid={Boolean((touched && error) || hasError)}
        aria-describedby={touched && error ? `${name}-error` : undefined}
        value={value}
        field={field}
        {...props}
      />

      {touched && error && (
        <div
          id={`${name}-error`}
          className="relative mt-1 block pl-4 text-sm text-red-600"
        >
          <FontAwesomeIcon icon={faCircleExclamation} className="mr-1.5" />
          {`${error.message}`}
        </div>
      )}
    </div>
  )
}
